import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import StageCrewLogo from '../components/StageCrewLogo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, setAccessDenied } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: { 'X-Session-ID': sessionId, 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        if (res.ok) {
          const data = await res.json();
          setUser(data);
          // Clear the fragment before navigation
          window.history.replaceState(null, '', window.location.pathname);
          // Check if the profile is complete; if not, funnel through onboarding.
          let target = '/';
          try {
            const p = await fetch(`${API}/profile/me`, { credentials: 'include' });
            if (p.ok) {
              const prof = await p.json();
              const incomplete = !prof.category || !prof.location || !prof.experience;
              if (incomplete) target = '/onboarding';
            }
          } catch { /* noop */ }
          navigate(target, { replace: true, state: { user: data } });
        } else {
          const error = await res.json();
          setUser(null);
          if (res.status === 403) setAccessDenied(error.detail);
          navigate('/login', { replace: true });
        }
      } catch {
        navigate('/login', { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser, setAccessDenied]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0C0E]">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-amber-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400 text-sm font-mono uppercase tracking-wider">Autenticando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
